import { ApiService } from "@/services/ApiService";
import { useEffect, useState } from "react";
import Table from "@/components/Table";
import { t } from "i18next";
import { useAuth } from "@/contexts/Auth";
import { checkHasPermission } from "@/lib/permissions";
import { useNavigate } from "react-router-dom";

const Clients = () => {
  const [apiData, setApiData] = useState<any>([]);
  const { get } = ApiService;
  const { usuario } = useAuth();
  const navigate = useNavigate();

  const formatCNPJ = (value: string) =>
    value
      ?.replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2");

  const columns = [
    {
      header: t("table.client.head.razaoSocial"),
      accessor: "razaoSocial",
    },
    {
      header: t("table.client.head.nomeFantasia"),
      accessor: "nomeFantasia",
    },
    {
      header: t("table.client.head.cnpj"),
      accessor: "cnpjFormatado",
    },
    {
      header: t("table.client.head.emailResponsavel"),
      accessor: "emailResponsavel",
    },
    {
      header: t("table.client.status"),
      accessor: "status",
    }
  ];

  const allowedActions = [];
  if (checkHasPermission(usuario?.permissoes, "ROLE_CLIENTE_EDITAR")) {
    allowedActions.push("editar");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_CLIENTE_DELETAR")) {
    allowedActions.push("remover");
  }

  const canAddNewClient = checkHasPermission(usuario?.permissoes, "ROLE_CLIENTE_REGISTRAR");

  useEffect(() => {
    const fetch = async () => {
      const { data } = await get("api/v1/cliente/listar");
      
      const formattedData = data.map((item: any) => ({
        ...item,
        cnpjFormatado: formatCNPJ(item.cnpj),
      }));

      setApiData(formattedData); 
    };

    fetch();
  }, [get]);

  return (
    <div className="flex-1 overflow-hidden p-8 max-md:px-4">
      <div className="mb-8 border-b pb-4">
        <h1 className='text-3xl font-medium mb-8'>{t("clientPage.title")}</h1>
      </div>
      {apiData && (
        <Table
          entity="cliente"
          baseRoute="api/v1/cliente"
          allowedActions={allowedActions}
          search={true}
          columns={columns}
          defaultData={apiData}
          buttonLabel={t("table.client.btn.add")}
          onButtonClick={() => navigate("registrar-cliente")}
          isButtonDisabled={!canAddNewClient}
        />
      )}
    </div>
  );
};

export default Clients;